module.exports = __webpack_public_path__ + "img/DefyHateNow-Logo-White.a40c3b60.svg";